import { render, staticRenderFns } from "./Xsell.vue?vue&type=template&id=45d641fe&scoped=true&lang=pug&functional=true&"
import script from "./Xsell.vue?vue&type=script&lang=js&"
export * from "./Xsell.vue?vue&type=script&lang=js&"
import style0 from "./Xsell.vue?vue&type=style&index=0&id=45d641fe&scoped=true&lang=stylus&"
import style1 from "./Xsell.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "45d641fe",
  null
  
)

export default component.exports